// Data utility to load products data based on locale, similar to master branch Angular implementation
import { productsData as defaultProductsData } from "./productsData";
import { productsData as zhCnProductsData } from "./zh_cn/productsData";
import { getLocaleKey } from "../utils/localizationHelper";

// Currently we have default and zh_cn locale data
const localeData = {
  default: {
    products: defaultProductsData,
  },
  zh_cn: {
    products: zhCnProductsData,
  },
};

export const getProductsData = (locale) => {
  // If no locale specified, use the active locale from localizationHelper
  const localeKey = locale || getLocaleKey();
  
  // Support using the default data for locales that don't supply their own
  const finalLocale = localeData[localeKey] ? localeKey : "default";

  console.log("[ProductsData] Using locale:", finalLocale);

  return localeData[finalLocale].products || [];
};

export const getAllLocaleData = () => {
  return localeData;
};
